(function () {
  'use strict';

  var flagsPromise;
  var mapPromise;

  function getFlagsUrl() {
    var el = document.querySelector('[data-language-flags-url]');
    return el ? el.getAttribute('data-language-flags-url') : '';
  }

  function getMapUrl() {
    var el = document.querySelector('[data-language-flag-map-url]');
    return el ? el.getAttribute('data-language-flag-map-url') : '';
  }

  function fetchJson(url) {
    return fetch(url).then(function (response) {
      if (!response.ok) throw new Error('Failed to load ' + url);
      return response.json();
    });
  }

  function loadAssets() {
    if (!flagsPromise) {
      flagsPromise = fetchJson(getFlagsUrl());
      mapPromise = fetchJson(getMapUrl());
    }
    return Promise.all([flagsPromise, mapPromise]);
  }

  /** Normalize Liquid iso_code (en, pt-BR) to Shopify LanguageCode (EN, PT_BR). */
  function normalizeLanguageCode(isoCode) {
    if (!isoCode) return '';
    return String(isoCode).trim().replace(/-/g, '_').toUpperCase();
  }

  function resolveCountryKey(isoCode, localeMap) {
    if (!isoCode) return null;

    var shopifyCode = normalizeLanguageCode(isoCode);

    if (localeMap[shopifyCode]) return localeMap[shopifyCode];

    var keys = Object.keys(localeMap);
    var i;

    for (i = 0; i < keys.length; i++) {
      if (normalizeLanguageCode(keys[i]) === shopifyCode) return localeMap[keys[i]];
    }

    var base = shopifyCode.split('_')[0];
    if (localeMap[base]) return localeMap[base];

    for (i = 0; i < keys.length; i++) {
      if (normalizeLanguageCode(keys[i]) === base) return localeMap[keys[i]];
    }

    return null;
  }

  function injectFlags(root) {
    var placeholders = (root || document).querySelectorAll('[data-language-flag]:not([data-flag-loaded])');
    if (!placeholders.length) return;

    loadAssets()
      .then(function (results) {
        var flags = results[0];
        var localeMap = results[1];

        placeholders.forEach(function (el) {
          var country = resolveCountryKey(el.getAttribute('data-language-flag'), localeMap);
          var svg = country && flags[country];

          if (svg) {
            el.innerHTML = svg;
          }

          el.setAttribute('data-flag-loaded', 'true');
        });
      })
      .catch(function () {
        placeholders.forEach(function (el) {
          el.setAttribute('data-flag-loaded', 'true');
        });
      });
  }

  function bindModal(modal) {
    var details = modal.querySelector('details');
    if (!details || details.dataset.flagsBound) return;
    details.dataset.flagsBound = 'true';

    details.addEventListener('toggle', function () {
      if (details.open) {
        injectFlags(modal);
        injectFlags(document.body);
      }
    });

    if (details.open) {
      injectFlags(modal);
      injectFlags(document.body);
    }
  }

  function init(scope) {
    var root = scope || document;
    root.querySelectorAll('.header-language-modal').forEach(bindModal);
    injectFlags(root.querySelector('.header-language-localization') || root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init();
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
